import { Stack, Typography } from '@mui/material';
import { isEmpty, isNil } from 'ramda';
import { useTranslation } from 'react-i18next';

import { SvbrgCatalogueItem } from '@/generated/gql/graphql';
import { I18nNamespace } from '~/common/types';

import { CatalogueDataGrid } from './CatalogueDataGrid';

interface CatalogueResultsGridProps {
  checkId: string;
  results: SvbrgCatalogueItem[];
}

export const CatalogueResultsGrid = ({ checkId, results }: CatalogueResultsGridProps) => {
  const { t } = useTranslation(I18nNamespace.intake, { keyPrefix: 'IntakeExtendedLineItemsCheckStep' });

  if (isNil(results) || isEmpty(results)) {
    return (
      <Typography variant="body2" color="text.secondary">
        {t('noCatalogueResults')}
      </Typography>
    );
  }

  return (
    <Stack spacing={2} maxWidth={'100%'}>
      <Typography variant="subtitle2">{t('catalogueResults')}</Typography>
      <CatalogueDataGrid checkId={checkId} rows={results} />
    </Stack>
  );
};
